module.exports = __webpack_public_path__ + "static/media/bg_01.7051102f.jpg";